<template>
  <b-modal 
    id="modal-add-certificate" 
    centered 
    hide-footer
    title="Add Certificate"
    size="lg"
    body-class="p-0">
    <div class="modal-container">
      <!-- Body -->
      <div class="modal-body p-4">
        <div class="row">
          <!-- Left Side - Certificate Detail -->
          <div class="col-md-6">
            <h6 class="font-weight-bold mb-4">Certificate Detail</h6>

            <!-- Type -->
            <div class="mb-3">
              <label class="form-label">Type<span class="text-danger">*</span></label>
              <v-select
                v-model="formData.type"
                :options="typeOptions"
                placeholder="Select Type"
                :clearable="false">
              </v-select>
            </div>

            <!-- Category -->
            <div class="mb-3">
              <label class="form-label">Category<span class="text-danger">*</span></label>
              <v-select
                v-model="formData.category"
                :options="categoryOptions"
                :reduce="option => option.value"
                label="label"
                placeholder="Select Category"
                :loading="categoryLoading"
                :clearable="false">
                <template #spinner="{ loading }">
                  <div v-if="loading" class="vs__spinner">Loading...</div>
                </template>
              </v-select>
            </div>

            <!-- Validity Period -->
            <!-- <div class="mb-3">
              <label class="form-label">Validity Period<span class="text-danger">*</span></label>
              <div class="row">
                <div class="col-6">
                  <label class="form-label small">Year (0-5)</label>
                  <v-select
                    v-model="formData.validityYear"
                    :options="yearOptions"
                    label="label"
                    :reduce="option => option.value"
                    placeholder="Year"
                    @input="onYearChange"
                    :clearable="false">
                  </v-select>
                </div>
                <div class="col-6">
                  <label class="form-label small">Month (0-12)</label>
                  <v-select
                    v-model="formData.validityMonth"
                    :options="currentMonthOptions"
                    label="label"
                    :reduce="option => option.value"
                    placeholder="Month"
                    :disabled="isMonthDisabled"
                    @input="onMonthChange"
                    :clearable="false">
                  </v-select>
                </div>
              </div>
              <small class="text-muted mt-2 d-block">
                Maximum: 5 years. Total selected: {{ totalValidityMonths }} months
              </small>
            </div> -->
          </div>

          <!-- Right Side - Preview -->
          <div class="col-md-6">
            <h6 class="font-weight-bold mb-4">Preview</h6>

            <!-- Upload Area -->
            <div 
              class="upload-area border rounded p-4 text-center"
              @click="triggerFileInput"
              @drop.prevent="handleDrop"
              @dragover.prevent
              @dragenter.prevent="isDragging = true"
              @dragleave.prevent="isDragging = false"
              :class="{ 'dragging': isDragging }">
              
              <div v-if="!previewImage">
                <i class="fe fe-upload-cloud mb-3" style="font-size: 3rem; color: #6c757d;"></i>
                <p class="mb-2 font-weight-bold">Drag and Drop the Document</p>
                <p class="text-muted small mb-3">Upload file .jpg,.jpeg,.png (Max. Size 2MB)</p>
                <button class="btn btn-sm btn-outline-danger" type="button">
                  Choose File
                </button>
              </div>

              <div v-else class="preview-container">
                <img :src="previewImage" alt="Preview" class="img-fluid">
                <button 
                  class="btn btn-sm btn-danger mt-3" 
                  type="button"
                  @click.stop="removeFile">
                  <i class="fe fe-trash-2 me-1"></i>
                  Remove
                </button>
              </div>
            </div>

            <!-- Hidden File Input -->
            <input 
              ref="fileInput"
              type="file" 
              class="d-none"
              accept=".jpg,.jpeg,.png"
              @change="handleFileSelect">
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer border-top">
        <button class="btn btn-danger px-4" @click="submitCertificate" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{ loading ? 'Mengirim...' : 'Submit' }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ModalAddCertificate',
  data() {
    return {
      typeOptions: ['Internal', 'External', 'Thematic'],
      categoryOptions: [],
      // yearOptions: [
      //   { label: '0 Year', value: 0 },
      //   { label: '1 Year', value: 1 },
      //   { label: '2 Years', value: 2 },
      //   { label: '3 Years', value: 3 },
      //   { label: '4 Years', value: 4 },
      //   { label: '5 Years', value: 5 }
      // ],
      // monthOptions: [
      //   { label: '0 Month', value: 0 },
      //   { label: '1 Month', value: 1 },
      //   { label: '2 Months', value: 2 },
      //   { label: '3 Months', value: 3 },
      //   { label: '4 Months', value: 4 },
      //   { label: '5 Months', value: 5 },
      //   { label: '6 Months', value: 6 },
      //   { label: '7 Months', value: 7 },
      //   { label: '8 Months', value: 8 },
      //   { label: '9 Months', value: 9 },
      //   { label: '10 Months', value: 10 },
      //   { label: '11 Months', value: 11 },
      //   { label: '12 Months', value: 12 }
      // ],
      isDragging: false,
      previewImage: null,
      formData: {
        type: '',
        category: '',
        // validityYear: 0,
        // validityMonth: 0,
        file: null
      }
    }
  },

  computed: {
    ...mapState('certificate', ['loading']),
    ...mapState('trainingCategory', {
      categoryLoading: state => state.loading
    }),

    // // Computed property for month options based on selected year
    // currentMonthOptions() {
    //   const selectedYear = this.formData.validityYear || 0;
    //   const maxTotalMonths = 60; // 5 years = 60 months
    //   const usedMonths = selectedYear * 12;
    //   const availableMonths = maxTotalMonths - usedMonths;
    //   
    //   return this.monthOptions.filter(month => month.value <= availableMonths);
    // },

    // // Check if month select should be disabled
    // isMonthDisabled() {
    //   return (this.formData.validityYear || 0) >= 5;
    // },

    // // Calculate total months selected
    // totalValidityMonths() {
    //   return (this.formData.validityYear || 0) * 12 + (this.formData.validityMonth || 0);
    // }
  },

  mounted() {
    this.loadCategories();

    // Listen for modal shown event to reload categories
    this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
      if (modalId === 'modal-add-certificate') {
        this.loadCategories();
      }
    });
  },

  beforeDestroy() {
    this.$root.$off('bv::modal::shown');
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('modal-add-certificate');
      this.resetForm();
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.processFile(file);
      }
    },

    handleDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      if (file) {
        this.processFile(file);
      }
    },

    processFile(file) {
      // Validate file type (image files)
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!validTypes.includes(file.type)) {
        this.$swal('Error', 'Unggah hanya file .jpg, .jpeg, atau .png', 'error');
        return;
      }

      // Validate file size (2MB)
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      if (file.size > maxSize) {
        this.$swal('Error', 'Ukuran file harus kurang dari 2MB', 'error');
        return;
      }

      this.formData.file = file;
      
      // Create preview for image
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeFile() {
      this.formData.file = null;
      this.previewImage = null;
      this.$refs.fileInput.value = '';
    },

    resetForm() {
      this.formData = {
        type: '',
        category: '',
        // validityYear: 0,
        // validityMonth: 0,
        file: null
      };
      this.previewImage = null;
      this.isDragging = false;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },

    // // Validity Period Methods
    // onYearChange() {
    //   // If year is 5, set month to 0 and disable month selection
    //   if (this.formData.validityYear >= 5) {
    //     this.formData.validityMonth = 0;
    //   }
    //   
    //   // Check if current month selection exceeds limit
    //   const maxAllowedMonths = (5 - this.formData.validityYear) * 12;
    //   if (this.formData.validityMonth > maxAllowedMonths) {
    //     this.formData.validityMonth = 0;
    //   }
    // },

    // onMonthChange() {
    //   // Month change handler (if needed for validation)
    // },

    ...mapActions('certificate', ['createCertificate']),
    ...mapActions('trainingCategory', ['getTrainingCategories']),

    async loadCategories() {
      try {
        const response = await this.getTrainingCategories({ page: 1, limit: 100 });
        
        // Map response to categoryOptions with label as title and value as id
        if (response.data && response.data.data) {
          this.categoryOptions = response.data.data.map(category => ({
            label: category.title,
            value: category.id
          }));
        }
      } catch (error) {
        console.error('Error loading categories:', error);
        this.$swal('Error', 'Kategori belum berhasil dimuat', 'error');
      }
    },

    async submitCertificate() {
      // Validation
      if (!this.formData.type) {
        this.$swal('Warning', 'Pilih tipe', 'warning');
        return;
      }
      if (!this.formData.category) {
        this.$swal('Warning', 'Pilih kategori', 'warning');
        return;
      }
      // if (this.totalValidityMonths === 0) {
      //   this.$swal('Warning', 'Pilih masa berlaku', 'warning');
      //   return;
      // }
      if (!this.formData.file) {
        this.$swal('Warning', 'Unggah file sertifikat', 'warning');
        return;
      }

      try {
        // Prepare FormData
        const formData = new FormData();
        formData.append('type', this.formData.type);
        formData.append('training_category_id', this.formData.category);
        // formData.append('validity_period_in_months', this.totalValidityMonths);
        formData.append('image', this.formData.file);

        // Call API
        await this.createCertificate(formData);
        
        // Emit success event to parent
        this.$emit('certificate-added');
        
        // Close modal and reset form
        this.closeModal();
      } catch (error) {
        console.error('Error creating certificate:', error);
        this.$swal('Error', 'Sertifikat belum berhasil dibuat. Silakan coba lagi.', 'error');
      }
    }
  }
}
</script>

<style scoped>
.modal-container {
  min-height: 400px;
}

.modal-header-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-close {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.btn-close:hover {
  opacity: 1;
}

.upload-area {
  background-color: #f8f9fa;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px dashed #dee2e6 !important;
}

.upload-area:hover {
  border-color: #e63757 !important;
  background-color: #fff5f7;
}

.upload-area.dragging {
  border-color: #e63757 !important;
  background-color: #fff5f7;
  transform: scale(1.02);
}

.preview-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-container img {
  max-height: 250px;
  object-fit: contain;
}

/* V-Select Custom Styles */
/* ::v-deep .v-select .vs__dropdown-toggle {
  border-color: #ced4da;
  border-radius: 0.375rem;
  padding: 0.375rem 0.75rem;
}

::v-deep .v-select.vs--open .vs__dropdown-toggle {
  border-color: #e63757;
  box-shadow: 0 0 0 0.2rem rgba(230, 55, 87, 0.25);
}

::v-deep .v-select .vs__selected {
  color: #2d3748;
  margin: 0;
  padding: 0;
}

::v-deep .v-select .vs__search {
  margin: 0;
  padding: 0;
}

::v-deep .v-select .vs__dropdown-menu {
  border-color: #e63757;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

::v-deep .v-select .vs__dropdown-option--highlight {
  background-color: #e63757;
  color: white;
} */
</style>
